import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'reisekosten-belege',
  title: 'Reisekosten & Belege',
  description:
    'Reisekosten und mitarbeiterbezogene Geschäftsausgaben erfassen, prüfen und abrechnen.',
  icon: 'Wallet',
  order: 70,
  apiBasePath: '/api/reisekosten-belege',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  roles: ['reisekosten-belege.nutzer', 'platform.admin'],

  routes: () => import('./src/routes'),
  surfaces: {
    'costs-v1': {
      title: 'Reisekosten & Belege',
      access: 'contextual',
      load: () => import('./src/integration/expense-summary'),
    },
    'capture-v1': {
      title: 'Reisekosten & Belege erfassen',
      access: 'contextual',
      load: () => import('./src/integration/expense-workspace'),
    },
  },

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
